export const add_func = (a,b,may = '', to = 0) => {
    if(!a || typeof(a) === 'undefined' || a === may){ a = to}
    if(!b || typeof(b) === 'undefined' || b === may){ b = to}
    let s = parseFloat(a) + parseFloat(b)
    if(s%1 == 0) return s
    return s.toFixed(1)
}
export function addFunc(a,b,c= 0, fix = false, to = 2) {
    if(!a || a == 'undefined' || typeof(a) == 'undefined' || a == null){
        a = 0;
    }
    if(!b || b == 'undefined' || typeof(b) == 'undefined' || b == null){
        b = 0;
    }
    if(!c || c == 'undefined' || typeof(c) == 'undefined' || c == null){
        c = 0;
    }
    var s = parseFloat(a) + parseFloat(b) + parseFloat(c)
    if(s%1==0 || !fix) return s
    return c.toFixed(to)
}
export function bolFunc(a,b,fix=false,to = 2){
    if(!a || a == 'undefined' || typeof(a) == 'undefined' || a == null || a === 0){
        return 0;
    }
    if(!b || b == 'undefined' || typeof(b) == 'undefined' || b == null || b === 0){
        return 0;
    }
    var c = parseFloat(a) / parseFloat(b)
    if(fix && c%1!=0){
        return c.toFixed(to)
    }
    return c

}
export function fixIt(a,to = 2){
    if(a == 0) return 0
    if(!a || a == 'undefined' || typeof(a) == 'undefined' || a == null){
        return '-';
    }
    if(parseFloat(a)%1==0) return a
    return parseFloat(a).toFixed(to)
}

export const foiz = (j,q) => {
    if(!j || typeof(j) == 'undefined' || j==0){
        return 0
    }
    if(!q || typeof(q) == 'undefined' || q==0){
        return 0
    }
    let f = q*100/j
    if(f%1==0) return f
    return f.toFixed(2)
}

export const avgFunc = (arr,fix=false,to=2) => {
    if(!arr.length) return 0
    let s = 0;
    let c = 0;
    for(let a = 0; a < arr.length; a++){
        if(!arr[a] || typeof(arr[a]) == "undefined") continue;
        s = addFunc(s,arr[a])
        c++
    }
    if(s == 0) return 0
    if(fix){
        return fixIt(bolFunc(parseFloat(s),c),to)
    }
    return bolFunc(parseFloat(s),c)
}